import React from 'react'
import MobileUserProfile from '@feature/portfolio/components/MobileUserProfileHeader/components/MobileUserProfile'
import MobileUserSubInformation from '@feature/portfolio/components/MobileUserProfileHeader/components/MobileUserSubInformation'
import MobileUserProfileOperations from '@feature/portfolio/components/MobileUserProfileHeader/components/MobileUserProfileOperations'

interface IProps {
    className?: string
    id?: string
    login_id?: string
}

const MobileUserProfileHeader = ({className, id, login_id}: IProps) => {
    return (
        <div className={`hidden sm:block pt-[20px] px-[10px] space-y-[7px] ${className}`}>
            <MobileUserProfile id={id} login_id={login_id} />

            <MobileUserSubInformation id={id} login_id={login_id} />

            <MobileUserProfileOperations id={id} login_id={login_id} />
        </div>
    )
}
export default MobileUserProfileHeader
